<template>
  <button
    type="button"
    class="btn my-1 d-flex align-items-center justify-content-center small-button"
  >
    <slot />{{ title }}
  </button>
</template>

<script>
export default {
  name: 'RuleSmallButton',
  props: {
    title: {
      required: true,
      type: String,
    },
  },
}
</script>

<style lang="scss" scoped>
.small-button {
  height: 1.75rem;
}
</style>
